import { render } from "./SmallKPI.vue?vue&type=template&id=29ad0e25"
import script from "./SmallKPI.vue?vue&type=script&lang=js"
export * from "./SmallKPI.vue?vue&type=script&lang=js"

import "./SmallKPI.vue?vue&type=style&index=0&id=29ad0e25&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__